import Immutable from 'immutable';

let memoValues = {};

export default function memoizeImmutable(name, value) {
    if (Immutable.is(memoValues[name], value)) {
        return memoValues[name];
    }
    memoValues[name] = value;
    return value;
}
